<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-4">
<h1>5</h1>
<p>I take Mary home, she breaks into tears, so I make tea and stay until I’m sure she’s more settled.</p>
<p>Before bedding down, I say aloud,</p><br/>
<p><em>“Yeshua, my Saviour, you have crossed my path with Mary Ford. Right now I’m tired, I need sleep, then you and I will see what we will do.”</em></p><br/>
<p>It’s 8:30 am when I wake and decide to fast this Sunday. I shower, shave, and dress. I take my yarmulke, prayer shawl, and drive downtown to my office. I take off my jacket, loosen my tie, put on my prayer shawl, read the Gospels, in the <em>B’rit Hadashah,</em> and talk to Yeshua.</p><br/>
<p><em>–</em> <em>It seems I’m to find the remains of Mary’s son twenty-two-years after he disappeared. I’ll need all the help you can give me to find his bones.</em></p>
<p><em>– I know, it won’t be easy to find the men who took Steven. Mary wants to talk to them. Wants to forgive them.</em></p>
<p><em>– Am I happy about what we’re going into? I’m not. There’ll be dark places I must go, evil I must meet. You didn’t want to go into the darkness Adonai wanted you to, but you went anyway out of love for us so that we can stand before Adonai with our sins forgiven.</em></p>
<p><em>– So I’ll go. You said, “How blessed are the poor in spirit.” My spirit, my will, sometimes gets too rich. Let your spirit prevail and your will, be done, so that throughout this quest, it’s not me who thinks, feels and acts, but you, through me.</em></p>
<p><em>– We need the names of those men who were there when Patrick fell.</em></p>
<p><em>– And the girl Steven took to the cinema a couple of times. When did they meet? Did they meet by chance? Was it planned that she should meet him?</em></p>
<p><em>– Mary doesn’t know her name or where she came from. We’ll need to see Steven’s room and to go through his things and maybe get a lead about the girl.</em></p>
<p><em>– Do you think his father’s death and his testifying against Blair and Scott are linked? We need to find out.</em></p><br/>
<p>My phone vibrates and rings. My ringtone is ‘Homecoming’ in waltz time. It tells me that my Ima, mother, is probably in the park using her phone.</p>
<p>“Hallo Ima,” I say.</p>
<p>“Where are you, Stanley? You’re not in your appartment.”</p>
<p>“Now you’re a detective.”</p>
<p>“I’m your mother, I like to know where you are.”</p>
<p>“I understood Abba, father, forbids you to contact me?”</p>
<p>“Your father can only forbid a wife, he cannot forbid a mother. Are you well, Stanley? Are you eating as you ought?”</p>
<p>“I am well with good appetite, Ima. In the vertical position, and, fighting off rigor mortis.”</p>
<p>“Like that you should joke? Are you using a strong sun screen this weather?”</p>
<p>“Are you using that parasol Abba bought you?”</p>
<p>“Dead, I would not be seen with that in Belfast.”</p>
<p>“How’s my sister Jo-Jo? Still going to marry the atheist?”</p>
<p>“Joanna wants you at her wedding.Your father’s not going if you’re there. You should hear him: ‘Two children I have, one wants to marry an atheist, and the other’s a goy.’”</p>
<p>“I’m not a goy, Ima. I’m a Jew who believes that our Messiah is Yeshua, whose, father is Adonai, the maker of the heavens and the earth.”</p>
<p>“When next you see him, don’t mention Yeshua.”</p>
<p>“Tell me about the man, JoJo’s going to marry.”</p>
<p>“He’s Jewish. His name is Joshua Horowitz. He’s comfortable. Will you go to the wedding?”</p>
<p>“If I’m asked.”</p>
<p>“You haven’t told me where you are.”</p>
<p>“In my office.”</p>
<p>“Such working. Stanley, you should be a nice Jewish rabbi like your father wanted.”</p>
<p>“I’m helping a widow find her son.”</p>
<p>“It’s good to look after widows and orphans. It’s in <em>Tanakh</em>.”</p>
<p>“Read the <em>B’rit Hadashah,</em> the New Covenant, it’s in that too.”</p>
<p>“Your father found it, and burned it.”</p>
<p>“I’ll get you a smarter phone with one on it.”</p>
<p>“I don’t want a phone that’s smarter than me.”</p>
<p>“There’s no phone smarter than you Ima. Love to Jo-Jo.”</p>
<p>“This widow’s son is missing?”</p>
<p>“His name is Steven, he’s missing, dead a long time.”</p>
<p>“Mazel tov, Stanley. Be careful of the sun in this weather. And no junk food. I’m told detectives eat a lot of junk food.”</p>
<p>“Shalom, Ima.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?37cebb3e